import { render } from "./referee-add-doctor.vue?vue&type=template&id=643b146a&scoped=true"
import script from "./referee-add-doctor.vue?vue&type=script&lang=js"
export * from "./referee-add-doctor.vue?vue&type=script&lang=js"

import "./referee-add-doctor.vue?vue&type=style&index=0&id=643b146a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-643b146a"]])

export default __exports__